<template>
    <div>
        <div :class="customClass" :id='randomId' :style="'width: 100%; height:' + this.height + 'px;'"></div>
    </div>
</template>

<script>
import MapService from '@/services/map.service'

export default {
    props: {
        markers: {
            type: Array,
        },
        selectedMarker: {
            type: Object,
        },
        position: {
            type: Object
        },
        customClass: {
            type: String
        },
        height: {
            default: 400
        },
        zoom: {
            default: 4
        }
    },
    data() {
        return {
            mapObject: null,
            randomId: null,
            markerElements: [],
            markerColor: "#50acde"
        }
    },
    watch: {
        markers: function(value) {
            this.initMap()
        },
        selectedMarker: function(value) {
            if (value) {
                this.selectMarker()
            } else {
                this.unselectMarkers()
                this.mapObject.flyTo({center: [this.positionData.longitude, this.positionData.latitude], zoom: this.positionData.zoom, duration: 2000});
            }
        }
    },
    computed: {
        positionData() {
            if (!this.position) {
                return {
                    longitude: "1.7191036",
                    latitude: "46.71109",
                    zoom: this.zoom
                }
            }
            return this.position
        }
    },
    methods: {
        initMap() {
            mapboxgl.accessToken = MapService.apiKey
            let zoom = this.positionData.zoom
            this.mapObject = new mapboxgl.Map({
                container: this.randomId,
                style: 'mapbox://styles/mapbox/streets-v11',
                center: [this.positionData.longitude, this.positionData.latitude],
                zoom
            });

            if (this.markers && this.markers.length > 0) {
                this.markerElements = []
                this.markers.forEach((marker) => {
                    let popup = null
                    if (marker.title || marker.description) {
                        popup = new mapboxgl.Popup({ offset: 25 }).setHTML(
                            '<h6 class="mb-0">' + marker.title + '</h6>' + marker.description
                        );
                    }
                    let markerEl = null
                    if (!marker.popup) {
                        markerEl = new mapboxgl.Marker({
                            color: marker.color ? marker.color : this.markerColor
                        })
                        .setLngLat([marker.longitude, marker.latitude])
                        .addTo(this.mapObject);
                    } else {
                        markerEl = new mapboxgl.Popup({closeButton: false, closeOnClick: false, className: "cursor-pointer opacity-60 hover:opacity-100 hover:z-10"})
                        .setLngLat([marker.longitude, marker.latitude])
                        .setHTML(marker.popup)
                        .addTo(this.mapObject);
                    }
                    if (markerEl) {
                        this.markerElements.push(markerEl)
                    }
                });
            }
        },

        changeMarker(marker, color, opacity, isSelected) {
            // if (marker._element) {
            //     if (isSelected) {
            //         marker._element.classList.add('opacity-100')
            //         marker._element.classList.add('z-10')
            //     } else {
            //         marker._element.classList.remove('opacity-100')
            //         marker._container.classList.add('opacity-60')
            //         marker._element.classList.remove('z-10')
            //     }
            //     marker._element.querySelectorAll('svg g[fill="' + marker._color + '"]')[0].setAttribute("fill", color);
            //     marker._color = color;
            // }
        },

        changePopup(marker, isSelected) {
            if (marker) {
                if (isSelected) {
                    marker._container.classList.add('opacity-100')
                    marker._container.classList.add('z-10')
                } else {
                    marker._container.classList.remove('opacity-100')
                    marker._container.classList.add('opacity-60')
                    marker._container.classList.remove('z-10')
                }
            }
        },

        selectMarker() {
            if (!this.selectedMarker)
                return
            let markerIndex = this.markers.findIndex((marker) => marker.map_id == this.selectedMarker.map_id)
            if (markerIndex >= 0) {
                this.unselectMarkers()

                let selectedMarker = this.markers[markerIndex]
                let selectedMarkerEl = this.markerElements[markerIndex]

                if (selectedMarkerEl._element) {
                    this.changeMarker(selectedMarkerEl, this.markerColor, 100, true)
                } else if (selectedMarkerEl._container) {
                    this.changePopup(selectedMarkerEl, true)   
                }
                this.mapObject.flyTo({center: [selectedMarker.longitude, selectedMarker.latitude], zoom: 16, duration: 2000});
            }

        },

        unselectMarkers() {
            this.markerElements.forEach((marker) => {
                if (marker._element) {
                    this.changeMarker(marker, this.markerColor, 50, false)
                } else if (marker._container) {
                    this.changePopup(marker, false)   
                }
            })
        }
    },
    mounted() {
        let randomToken = ''
        let length = 20
        let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
        let charactersLength = characters.length

        for (let i = 0; i < length; i++) {
            randomToken += characters.charAt(Math.floor(Math.random() * charactersLength))
        }
        this.randomId = 'map-' + randomToken

        this.$nextTick(() => {
            this.initMap()
            if (this.selectedMarker) {
                this.selectMarker()
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SavMap2.vue